import _regeneratorRuntime from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import "core-js/modules/es6.set";
import _toConsumableArray from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/app/node_modules/.pnpm/@babel+runtime-corejs2@7.24.1/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";
import { getLanguagePack } from '@/api/translate';
import { getApiLanguageCode } from '@/i18n';

// 缓存已翻译的内容
var translationCache = new Map();

// 批量翻译的队列
var translationQueue = [];
var translationTimer = null;
export default {
  bind: function bind(el, binding) {
    var text = el.textContent.trim();
    if (text.startsWith('i18n_')) {
      translateText(el, text);
    }
  },
  update: function update(el, binding) {
    var text = el.textContent.trim();
    if (text.startsWith('i18n_')) {
      translateText(el, text);
    }
  }
};

// 批量翻译函数，可被外部调用
export function batchTranslate(_x) {
  return _batchTranslate.apply(this, arguments);
}

// 翻译文本
function _batchTranslate() {
  _batchTranslate = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(keys) {
    var uncachedKeys, uniqueKeys, response, translations, result;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // 过滤掉已经缓存的键，获取未缓存的键
          uncachedKeys = keys.filter(function (key) {
            return !translationCache.has(key);
          });
          uniqueKeys = _toConsumableArray(new Set(uncachedKeys)); // 去重
          // 如果有未缓存的键，则请求翻译
          if (!(uniqueKeys.length > 0)) {
            _context.next = 14;
            break;
          }
          _context.prev = 3;
          _context.next = 6;
          return getLanguagePack({
            language_pack_keys: uniqueKeys,
            language: getApiLanguageCode()
          });
        case 6:
          response = _context.sent;
          translations = response.language_pack_list; // 更新缓存
          Object.keys(translations).forEach(function (key) {
            if (translations[key]) {
              translationCache.set(key, translations[key].translate);
            }
          });
          _context.next = 14;
          break;
        case 11:
          _context.prev = 11;
          _context.t0 = _context["catch"](3);
          console.error('Batch translation error:', _context.t0);
        case 14:
          // 返回所有键的翻译结果（包括缓存中已有的）
          result = new Map();
          keys.forEach(function (key) {
            if (translationCache.has(key)) {
              result.set(key, translationCache.get(key));
            } else {
              result.set(key, key); // 如果没有翻译，返回原键
            }
          });
          return _context.abrupt("return", result);
        case 17:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 11]]);
  }));
  return _batchTranslate.apply(this, arguments);
}
function translateText(el, key) {
  // 如果缓存中有，直接使用
  if (translationCache.has(key)) {
    el.textContent = translationCache.get(key);
    return;
  }

  // 将需要翻译的key加入队列
  translationQueue.push({
    el: el,
    key: key
  });

  // 使用防抖，等待一段时间后批量请求
  if (translationTimer) {
    clearTimeout(translationTimer);
  }
  translationTimer = setTimeout(function () {
    var keys = translationQueue.map(function (item) {
      return item.key;
    });
    var uniqueKeys = _toConsumableArray(new Set(keys)); // 去重

    getLanguagePack({
      language_pack_keys: uniqueKeys,
      language: getApiLanguageCode()
    }).then(function (response) {
      var translations = response.language_pack_list;

      // 更新缓存和元素内容
      translationQueue.forEach(function (item) {
        var translation = translations[item.key];
        if (translation) {
          translationCache.set(item.key, translation.translate);
          item.el.textContent = translation.translate;
        }
      });

      // 清空队列
      translationQueue = [];
    }).catch(function (error) {
      console.error('Translation error:', error);
      translationQueue = [];
    });
  }, 100); // 等待100ms后批量请求
}